package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /support route — redirects to /inbox?tab=support.
 *
 * Content has fully moved to the «Обращения» tab of InboxPage (R7).
 * This stub keeps old bookmarks and external links working.
 *
 * URL param mapping:
 *   ?q=…    → forwarded as ?q=…      (search query)
 *   ?page=… → forwarded as ?page=…   (pagination offset)
 */
@Page("/support")
@Composable
fun SupportPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val params = buildString {
            val q = urlParam("q")?.ifBlank { null }
            val page = urlParam("page")?.ifBlank { null }
            if (q != null) append("&q=${encodeQueryValue(q)}")
            if (page != null) append("&page=${encodeQueryValue(page)}")
        }
        ctx.router.navigateTo("${Routes.INBOX}?tab=support$params")
    }
}
